import { Skeleton as MSkeleton, SkeletonProps } from '@mui/material';
import cx from 'classnames';
import css from './Skeleton.module.scss';

/** @deprecated Use `components/ui/Skeleton` instead. */
export const Skeleton = ({ className, ...rest }: SkeletonProps) => (
  <MSkeleton
    className={cx(css.skeleton, className)}
    animation="pulse"
    variant="rectangular"
    {...rest}
  />
);
